import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable()
export class ActionPlanResponseService {
  path = "/action-plan-response";

  constructor(private baseService: BaseService) {}

  getPaginated(init: number, end: number, filters: object) {
    return this.baseService.get(this.path, "", { init, end, ...filters });
  }

  getByActionPlan(id: number) {
    return this.baseService.get(this.path, `/byActionPlan/${id}`, { id });
  }

  createAnswer(actionPlanId, data) {
    return this.baseService.post(this.path, '', {action_plan_id: actionPlanId, data})
  }


  delete(answerId) {
    return this.baseService.delete(this.path, `/${answerId}`)
  }

  //   exportCsv(filters: object) {
  //     return this.baseService.get(this.path, "/export/csv", filters);
  //   }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/action-plan-response.service.ts